import PropTypes from 'prop-types'
import React from 'react'
import get from 'lodash-es/get'

const renderMatrix = ({
  itemMatrix,
  selectedMatrixLicense,
  selectedMatrixSupport,
  showChangeDetailsLink,
  goToEditScreen,
  cartEntry
}) => {
  const hasItemSupport =
    itemMatrix &&
    Object.keys(itemMatrix).some(license => {
      const { support } = itemMatrix[license]
      return Object.keys(support).some(supportName => {
        return support[supportName] && supportName !== 'none'
      })
    })
  const supportOptions = get(itemMatrix[selectedMatrixLicense], 'support')

  const onGoToEditScreen = e => {
    e.preventDefault()
    goToEditScreen()
  }

  return (
    <div className="cart-modal__variant-info">
      <p className="fds-c-text-heading -size-l">
        <b className="fds-c-text-currency">
          {get(supportOptions[selectedMatrixSupport], 'price')}
        </b>
      </p>
      <p className="fds-c-text-body -weight-bold -size-s fds-u-mb0">
        <span>License: </span>
        <a
          href={get(itemMatrix[selectedMatrixLicense], 'terms_url')}
          className="fds-c-text-link -size-m -weight-normal -decoration-none"
        >
          {get(itemMatrix[selectedMatrixLicense], 'license_label')}
        </a>
      </p>
      {hasItemSupport && (
        <p className="fds-c-text-body -weight-bold -size-s fds-u-mb0">
          <span>Support: </span>
          <span className="fds-c-text-body -weight-normal -size-s">
            {get(supportOptions[selectedMatrixSupport], 'label')}
          </span>
        </p>
      )}
      {showChangeDetailsLink &&
        cartEntry && (
          <p className="fds-c-text-body -weight-bold -size-s fds-u-mb0">
            <a
              href={`/cart/edit/${cartEntry.id}`}
              onClick={onGoToEditScreen}
              className="fds-c-text-link -size-m -weight-normal"
            >
              Change details
            </a>
          </p>
        )}
    </div>
  )
}

const ItemSummary = ({
  item,
  itemMatrix,
  selectedMatrixLicense,
  selectedMatrixSupport,
  showChangeDetailsLink,
  goToEditScreen,
  cartEntry
}) => (
  <div className="fds-c-modal__section -background-mid -height-scroll fds-u-p2 ">
    <div className="cart-modal__thumbnail">
      <img alt={item.name} src={item.ui.smallPreviewUrl} />
    </div>
    <div className="cart-modal__core-info">
      <h5 className="fds-c-text-heading -size-xxs">{item.name}</h5>
      <p className="fds-c-text-body -size-s">
        by{' '}
        <span className="fds-c-text-body -size-s -style-italic">
          {item.author_username}
        </span>
      </p>
    </div>

    {itemMatrix &&
      selectedMatrixLicense &&
      renderMatrix({
        itemMatrix,
        selectedMatrixLicense,
        selectedMatrixSupport,
        showChangeDetailsLink,
        goToEditScreen,
        cartEntry
      })}
  </div>
)

ItemSummary.propTypes = {
  item: PropTypes.object.isRequired,
  itemMatrix: PropTypes.object,
  selectedMatrixLicense: PropTypes.string,
  selectedMatrixSupport: PropTypes.string,
  showChangeDetailsLink: PropTypes.bool,
  goToEditScreen: PropTypes.func,
  cartEntry: PropTypes.object
}

export default ItemSummary
